import DayOfWeekSelectionComponent from '@sophocles/components/DayOfWeekSelectionComponent/DayOfWeekSelectionComponent';

export default DayOfWeekSelectionComponent;
